export const subscriptionActionTypes = {
	SET_CURRENT_SUBSCRIPTION: 'SET_CURRENT_SUBSCRIPTION',
};
